import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { NavbarContext } from "../../context";
import { experienceHighlights } from "../../data/portfolioData";

const ExpEntry = ({ data, index }) => {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <div
      ref={ref}
      className={`exp-entry fade-up${inView ? " visible" : ""}`}
      style={{ transitionDelay: `${index * 0.1}s` }}
    >
      <p className="exp-company">{data.company}</p>
      <div className="exp-period-role">
        <span className="exp-period">{data.period}</span>
        <span className="exp-role">{data.role}</span>
      </div>
      <p className="exp-summary">{data.summary}</p>
      <div className="exp-tags">
        {data.points.map((pt) => (
          <span key={pt} className="exp-tag">{pt}</span>
        ))}
      </div>
    </div>
  );
};

export const Experience = () => {
  const { ref, inView } = useInView({ threshold: 0.25 });
  const setPage = useContext(NavbarContext);

  useEffect(() => {
    if (inView) setPage("experience");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <section
      ref={ref}
      id="experience-page"
      className="experience-section"
      aria-label="Experience"
    >
      <div className="container-wide">
        <h2 className="section-heading">
          Where I've worked.
        </h2>
        <p className="section-sub">
          From a Scrum team at FPT Software to running projects for business owners.
        </p>

        <div className="experience-grid">
          {/* Sticky sidebar label */}
          <div className="exp-sidebar" aria-hidden="true">
            <span className="exp-sidebar-label">experience</span>
          </div>

          {/* Timeline entries */}
          <div className="exp-entries">
            {experienceHighlights.map((exp, i) => (
              <ExpEntry key={i} data={exp} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
